import { useAdminStore } from '@/pages/admin/store/useAdmin.store';
import { useDashboardStore } from '../store/useDashboardStore';
import EngamentPastWeek from './engament-past-week';
import Mood from './mood';
import Survey from './survey';

export default function Header() {
  const { totalUsers } = useDashboardStore();
  const { page } = useAdminStore();

  return (
    <>
      <div className="flex flex-col items-center justify-center rounded-2xl border border-[#777] p-5">
        <p className=" text-center text-sh-xss">{page?.dashboard?.header?.totalUsers || 'Total users'}</p>
        <p className=" text-sh-md font-bold"> {totalUsers ? totalUsers : '-'}</p>
      </div>
      <div className="flex flex-col items-center justify-center rounded-2xl border border-[#777] p-5">
        <p className="text-center text-sh-xss">{page?.dashboard?.header?.overallMood || 'Overall Mood'}</p>
        <Mood />
      </div>
      <div className="flex flex-col items-center justify-center rounded-2xl border border-[#777] p-5">
        <p className="text-center text-sh-xss">
          {page?.dashboard?.header?.engagementPastWeek || 'Engagement past week'}{' '}
        </p>
        <EngamentPastWeek />
      </div>
      <div className="flex flex-col items-center justify-center rounded-2xl border border-[#777] p-5">
        <p className="text-center text-sh-xss">{page?.dashboard?.header?.surveysResponse || 'Surveys response'}</p>
        <Survey />
      </div>
    </>
  );
}
